import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import CategoryView from "../../components/CategoryView";
import ExpenseCard from "./ExpenseCard";
import "./Expenses.css";
import "react-toastify/dist/ReactToastify.css";
import dbFirebase from "../../firebase";

const Expenses = () => {
  const [fbData, setFbData] = useState([]);

  useEffect(() => {
    dbFirebase.collection("expenses").onSnapshot((snapshot) => {
      setFbData(snapshot.docs.map((doc) => ({ uid: doc.id, exp: doc.data() })));
    });
  }, []);

  const expenseListArray = fbData.map((ex) => ex.exp);
  const searchString = useSelector((state) => state.searchString);
  const filteredExpenses = expenseListArray.filter((exp) =>
    exp.title.toLowerCase().includes(searchString.toLowerCase())
  );

  // filter by category
  const categoryFilter = useSelector((state) => state.categoryFilter);
  const categoryFilterToggle = useSelector(
    (state) => state.categoryFilterToggle
  );

  const filteredExpensesSorted =
    categoryFilter && categoryFilterToggle
      ? filteredExpenses.filter((exp) => exp.category === categoryFilter)
      : filteredExpenses;

  const deleteSuccess = () => {
    toast.info("expense delete successful");
  };

  return (
    <div className="expenses__container">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <CategoryView />
      <div className="expenses__Box">
        {expenseListArray.length ? (
          filteredExpensesSorted.map((list, i) => (
            <ExpenseCard
              expense={list}
              delKey={fbData[i]}
              deleteNotify={deleteSuccess}
            ></ExpenseCard>
          ))
        ) : (
          <div className="empty__expensesContainer">Add New Expenses</div>
        )}
      </div>
    </div>
  );
};

export default Expenses;
